import React, { useState, useContext, useRef } from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DatePicker, { CalendarContainer } from "react-datepicker";
import NumberFormat from 'react-number-format';

// import { } from '@fortawesome/free-solid-svg-icons';
import { faHandPointDown, faEdit } from '@fortawesome/free-regular-svg-icons';
import { changeDataToDDMMYYYY2 } from '../../../utils/Date/SupportDate';
import { UserContext } from '../../../container/MakeRoom/index';

import RoomDropDown from '../../Unit/RoomDropDown';
import DropDownAction from '../../../features/DropDown';
//--CSS-
import './makeRoomDataRoom.css';
import 'font-awesome/css/font-awesome.min.css';
import "react-datepicker/dist/react-datepicker.css";
import { changeStringVNDtoNumber } from '../../../utils/Currency/SupportCurrency';

function MakeRoomDataRoomDetails(props) {
    const { style } = useContext(UserContext);
    const dataMakeRoom = useSelector(state => state.makeRoom);
    const dataMakeRoomOther = useSelector(state => state.makeRoomOther);
    const auth = useSelector(state => state.auth);
    const { role, branchID } = auth.user;
    const isEdit = dataMakeRoomOther.area !== "cancel" && (role === 0 || role === 2 || role === 3);
    const [, setRoomError] = useState(false);
    const [isFocusPrice, setIsFocusPrice] = useState(false);
    const [priceInclueVAT, setPriceIncludeVAT] = useState("");
    const [priceInclueVATResult, setPriceIncludeVATResult] = useState("");
    const [nights, setNights] = useState(1);
    const [rateExchangePriceVAT, setRateExchangePriceVAT] = useState(0.08);

    let valueTimeSave = useRef("");

   // const REQUEST_CASE_EXTENT = dataMakeRoom.listRequest1;
    const REQUEST_CASE = {
        0: "",
        1: "Company have contract 5% OFF",
        2: "Company have contract free laundry 120.000vnd/day",
        3: "Company have contract 5% OFF + free laundry 120.000vnd/day",
        4: "Walk In guest",
        5: "Shortime guest",
        6: "Line Coupon Discount",
    };

    const REQUEST_CASE2 = {
        0: "",
        1: "Company have contract 5% OFF",
        2: "Company have contract free laundry 5.5$/day",
        3: "Company have contract 5% OFF + free laundry 5.5$/day",
        4: "Walk In guest",
        5: "Shortime guest",
        6: "Line Coupon Discount",
    }

    const REQUEST_CASE3 = {
        0: "",
        1: "2 water",
        2: "Full minibar",
        3: "Exclude Breakfast",
    }

    function renderRequest1Extend() {
        var result = [];

        if (dataMakeRoom.listRequest1.length !== 0) {
            dataMakeRoom.listRequest1.forEach((item, index) => {
                result.push(<button className="btn btn-success mr-2 mt-1"
                    onClick={() => onChangeData(item.value, "request1", "extend")}>
                    {item.name}</button>)
            })
        }

        // result.push(<button className="btn btn-primary"
        //                         onClick={()=>props.onOpenSettingRequest1()}>Edit</button>)

        result.push( <FontAwesomeIcon
                        icon={faEdit}
                        onClick={()=>props.onOpenSettingRequest1()}
                        style={style.icon} />)
        return result;
    }

    function onChangeData(value, target, option) {
        // console.log("value", value)
        // console.log("target", target)

         if((target === "timeEarly" || target === "timeLateOut") && valueTimeSave.current === "") {
            valueTimeSave.current = dataMakeRoom.listSchedule[option][target];
         } 
         props.onChangeValueMakeRoom(value, target, option);
    }

    // function onBlurCheckTimeFormat(value, target, option) {
    //     const isValid = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(value);
    //     if (isValid) {
    //         valueTimeSave.current = "";
    //     } else {
    //         props.onChangeValueMakeRoom(valueTimeSave.current, target, option);
    //         valueTimeSave.current = "";
    //     }
    // }

    function checkRoomNumber(value, index) {
        if (dataMakeRoom.listRoomPrice[dataMakeRoom.roomSelect]) {
            setRoomError(false);
        } else setRoomError(true);
    }

    function onChangePriceIncludeVAT(value, target) {
        // 1. Lấy giá trị mới nhất dựa trên target đang thay đổi
        const currentPriceStr = target === "value" ? value : priceInclueVAT; // Đã sửa lỗi thiếu chữ 'd'
        const currentNights = target === "nights" ? Number(value) : Number(nights);
        const currentVatRate = target === "vat" || (target !== "value" && target !== "nights") 
            ? Number(value) 
            : Number(rateExchangePriceVAT);

        // 2. Cập nhật state tương ứng
        if (target === "value") {
            setPriceIncludeVAT(value);
        } else if (target === "nights") {
            setNights(currentNights);
        } else {
            setRateExchangePriceVAT(currentVatRate);
        }

        // 3. Kiểm tra an toàn (tránh chia cho 0 hoặc NaN khi user đang xóa trắng ô input)
        const numericPrice = changeStringVNDtoNumber(currentPriceStr);
        if (!numericPrice || !currentNights || currentNights <= 0 || isNaN(currentVatRate)) {
            setPriceIncludeVATResult(0);
            return;
        }

        // 4. Tính toán 1 lần duy nhất
        const result = Math.round(numericPrice / currentNights / (1 + currentVatRate));
        setPriceIncludeVATResult(result);
    }

    function onChangeRequest(type, request) {
        const index = dataMakeRoom.scheduleSelect;

        switch (request) {
            case 1:
                if(branchID === 11 || branchID === 97) {
                    onChangeData(REQUEST_CASE2[type], "request"+request, "");
                } else {
                   onChangeData(REQUEST_CASE[type], "request"+request, type);
                }

                if (type === 5) {
                    onChangeData(true, "shortime", index);
                }
                break;

            case 2: {
                let changeContent;
                if(dataMakeRoom.request2 === "" ) onChangeData(REQUEST_CASE3[type], "request"+request, "");
                else {
                    if(type === 0 ) {
                        if(dataMakeRoom.request2.includes("2 water")) {
                            changeContent = dataMakeRoom.request2.replace("2 water", "")
                            changeContent.replace("2 water,", "")

                            onChangeData(changeContent, "request"+request, "");
                        }
                    }  else onChangeData(REQUEST_CASE3[type] + ", " + dataMakeRoom.request2, "request"+request, "");
                }

                if (type === 3) {
                    onChangeData(true, "isNonBreakfast", index);
                    // onChangeData("NON BREAKFAST", "request1", "extend")
                } else if (type === 0 && dataMakeRoom.listSchedule[index]?.isNonBreakfast) {
                    onChangeData(false, "isNonBreakfast", index);
                    // onChangeData("NON BREAKFAST", "request1", "extend")
                }
                break;
            };

            default: break;
        }
    }

    const DatePickUpCalenderContainer = ({ className, children }) => {
        return (
          <div style={{ padding: "3px", background: "#216ba5", color: "#fff" }}>
            <CalendarContainer className={className}>
              <div style={{ position: "relative" }}>{children}</div>
            </CalendarContainer>
          </div>
        );
      };

    function renderSchedule() {
        const index = dataMakeRoom.scheduleSelect;
        const dataRender = dataMakeRoom.listSchedule[index];

        if (!dataRender) return null;

        return (
            <div style={{ paddingTop: '4px' }}>
                                {/* Room */}
                <div style={{ position: "relative" }}
                     className="d-flex align-items-center makeRoom_children ">
                    <label className='makeRoom_label ml-2'>Room</label>
                    <input
                        type="text"
                        maxlength="4"
                        disabled={dataRender.move || (role !== 0 && role !== 2 && role !== 3)}
                        style={{ width: '50px', fontSize: '1.4rem', color: dataRender.move? "red": "" }}
                        value={dataRender.roomSelect}
                        onFocus={() => setRoomError(false)}
                        onBlur={e => checkRoomNumber(e.target.value, index)}
                        onChange={e => onChangeData(e.target.value, "roomSelect", index)}
                    />
                    <div className="makeRoom_children d-flex">
                        <input
                            onChange={e => onChangeData(e.target.value, "move", index)}
                            type="checkbox"
                            disabled={(role !== 0 && role !== 2 && role !== 3)}
                            id="move"
                            name="move"
                            checked={dataRender.move}
                            value="move" />
                        <label for="move" 
                         className='makeRoom_text'
                        // style={style.text}
                        >Don't move</label>
                    </div>
                    {/* <div style={{
                        color: 'red',
                        fontWeight: 'bold',
                        display: !roomError ? "none" : "block"
                    }}>( Room error)</div> */}

                    <RoomDropDown
                        onBlur={value => onChangeData(value, "roomSelect", index)}
                        data={dataMakeRoom.listRoomNumber}
                        room={dataRender.roomSelect} />
                    {/* Price */}
                    <div className="d-flex ml-5">
                        <label className='makeRoom_label mr-5'>{Number(branchID)  === 11 || Number(branchID)  === 97 ? "Price(USD)": "Price(VND)"}</label>
                        {/* <input
                            type="number"
                            value={dataRender.price}
                            disabled={!isEdit}
                            style={{ width: '70px', fontSize: '1.4rem' }}
                            onChange={e => onChangeData(e.target.value, "price", index)} /> */}

                        <NumberFormat
                            thousandSeparator={true}
                            type="text"
                            name="pickupPrice" 
                            min="0"
                            style={{ width: '80px', fontSize: '1.4rem', color: dataRender.lockPrice ? "red" : ""}}
                            value={dataRender.price}
                            disabled={!isEdit || dataRender.lockPrice}

                            onChange={e => onChangeData(e.target.value, "price", index)}
                        />

                        <select
                            onChange={e => onChangeData(e.target.value, "discount", index)}
                            name="discount"
                            id="discount"
                            disabled={!isEdit}
                            className="form-control editor"
                            style={{ width: '70px' }}>
                            <option value="0" selected="">{dataRender.discount === "0" ? "No discount" : dataRender.discount + "%"}</option>                        
                            <option value="0">{"No discount"}</option>
                            <option value="5">5%</option>
                            <option value="10">10%</option>
                            <option value="15">15%</option>
                            <option value="20">20%</option>
                            <option value="25">25%</option>
                            <option value="30">30%</option>
                            <option value="35">35%</option>
                            <option value="40">40%</option>
                            <option value="45">45%</option>
                            <option value="50">50%</option>
                            <option value="100">100%</option>
                        </select>

                        {/* <input
                                    onChange={e => onChangeData(!dataRender.lockPrice, "lockPrice", index)}
                                    type="checkbox"
                                    disabled={(role !== 0 && role !== 2 && role !== 3)}
                                    id="lockPrice"
                                    name="lockPrice"
                                    checked={dataRender.lockPrice}
                                    />
                                <label for="lockPrice" 
                                className='makeRoom_text'
                                // style={style.text}
                                >Lock Price</label> */}

                        <i className="fa-solid fa-gear" 
                           style={{fontSize:'2rem', margin:'auto', cursor:'pointer', color:'#482979'}}
                           onMouseEnter={() => setIsFocusPrice(true)}
                          // onMouseLeave={() => setIsFocusPrice(false)} 
                           ></i>
                    </div>

                    {isFocusPrice && <div className='chat-box' 
                        onMouseEnter={() => setIsFocusPrice(true)} 
                        onMouseLeave={() => setIsFocusPrice(false)}>
                     <div>
                            <div style={{marginLeft:'160px'}}>
                                <input
                                    onChange={e => onChangeData(!dataRender.lockPrice, "lockPrice", index)}
                                    type="checkbox"
                                    disabled={(role !== 0 && role !== 2 && role !== 3)}
                                    id="lockPrice"
                                    name="lockPrice"
                                    checked={dataRender.lockPrice}
                                    />
                                <label for="lockPrice" 
                                className='makeRoom_text'
                                // style={style.text}
                                >Lock Price</label>

                                <button  onClick={() => setIsFocusPrice(false)} style={{background:'red', minWidth:'10px', marginLeft:'20px' }}>X</button>

                            </div>
                        <div  className='d-flex'> 
                            <div>   
                                <div style={{fontSize:'1.2rem'}}>*Price include VAT</div>
                                
                                <NumberFormat
                                    thousandSeparator={true}
                                    type="text"
                                    name="pickupPrice" 
                                    min="0"
                                    style={{ width: '100px', fontSize: '1.4rem' }}
                                    value={priceInclueVAT}
                                    disabled={!isEdit || dataRender.lockPrice}
                                    onFocus={() => setIsFocusPrice(true)}
                                    onChange={e => onChangePriceIncludeVAT(e.target.value, "value")}
                                />
                            </div>

                            <div className='ml-2'>   
                                <div style={{fontSize:'1.2rem'}}>*Nights</div>
                                
                                <NumberFormat
                                    thousandSeparator={true}
                                    type="text"
                                    name="nights" 
                                    min="0"
                                    style={{ width: '20px', fontSize: '1.4rem' }}
                                    value={nights}
                                    disabled={!isEdit || dataRender.lockPrice}
                                    onFocus={() => setIsFocusPrice(true)}
                                    onChange={e => onChangePriceIncludeVAT(e.target.value, "nights")}
                                />
                            </div>

                            <span style={{fontSize: '2rem', marginTop: '10px'}}> = </span>

                            <div className='ml-2'>
                                <div style={{fontSize:'1.2rem'}}>*Result change price</div>
                                <div>
                                    <NumberFormat
                                        thousandSeparator={true}
                                        type="text"
                                        name="pickupPrice" 
                                        min="0"
                                        style={{ width: '100px', fontSize: '1.4rem' }}
                                        value={priceInclueVATResult}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>

                        
                     </div>

                    <div >
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="exchangePrice" id="exChangePrice1" value={0.08}
                                checked={rateExchangePriceVAT === 0.08}
                                disabled={!isEdit}
                                onChange={e => onChangePriceIncludeVAT(e.target.value, "rate")} />
                            <label className="form-check-label" for="exChangePrice1" style={style.text}>8%</label>
                        </div>

                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="exchangePrice" id="exChangePrice2" value={0.1}
                                checked={rateExchangePriceVAT === 0.1}
                                disabled={!isEdit}
                                onChange={e => onChangePriceIncludeVAT(e.target.value, "rate")} />
                            <label className="form-check-label" for="exChangePrice2" style={style.text}>10%</label>
                        </div>
                    </div>

                    <button disabled={dataRender.lockPrice} className='btn btn-primary mt-2' onClick={() => onChangeData(priceInclueVATResult, "price", index)} >Add to price</button>
                    </div>}
                </div>

                 {/* Date Stay */}
                <div style={style.children} className="d-flex">
                    <label 
                    // style={style.label} 
                     className='makeRoom_label'
                    >Date Stay</label>
                    <div>
                        <div className='d-flex'>
                            <label 
                                // style={style.text}
                                className="makeRoom_text mr-2"
                                style={{fontWeight:'500'}}
                                >Check In: </label>
                            <div style={style.text} className='makeRoom-checkInOut'>
                                <DatePicker
                                    selected={dataRender.checkin === "" ? "" : new Date(dataRender.checkin)}
                                    dateFormat="dd-MM-yyyy"
                                    onChange={(date) => onChangeData(date, "checkin", index)} 
                                    selectsStart
                                    startDate=""
                                    disabled={(role !== 0 && role !== 2 && role !== 3)}
                                    // startDate={dataRender.checkin === "" ? "" : new Date(dataRender.checkin)}
                                    endDate={dataRender.checkout === "" ? "" : new Date(dataRender.checkout)}
                                    //minDate={dataRender.checkin === "" ? "" :  new Date(dataRender.checkin)} 
                                    monthsShown={2}
                                    popperClassName="some-custom-class"
                                    popperPlacement="bottom-start"
                                    calendarContainer={DatePickUpCalenderContainer}
                                    popperModifiers={[
                                        {
                                          name: "offset",
                                          options: {
                                            offset: [5, 10],
                                          },
                                        },
                                        {
                                          name: "preventOverflow",
                                          options: {
                                            rootBoundary: "viewport",
                                            tether: false,
                                            altAxis: true,
                                          },
                                        },
                                      ]}
                                />
                            </div>
                            <label 
                                className="ml-3 mr-2 makeRoom_text"
                                style={{fontWeight:'500'}}
                                >Check Out: </label>
                            <div style={style.text} className='makeRoom-checkInOut'>
                                <DatePicker
                                    selected={dataRender.checkout === "" ? "" :  new Date(dataRender.checkout)} 
                                    dateFormat="dd-MM-yyyy"
                                    onChange={(date) => onChangeData(date, "checkout", index)} 
                                    selectsEnd
                                    disabled={(role !== 0 && role !== 2 && role !== 3)}
                                    startDate={dataRender.checkin === "" ? "" :  new Date(dataRender.checkin)} 
                                    endDate={dataRender.checkout === "" ? "" :  new Date(dataRender.checkout)} 
                                    minDate={dataRender.checkin === "" ? "" :  new Date(dataRender.checkin)} 
                                    monthsShown={2}
                                    popperClassName="some-custom-class"
                                    popperPlacement="bottom-start"
                                    calendarContainer={DatePickUpCalenderContainer}
                                    popperModifiers={[
                                        {
                                          name: "offset",
                                          options: {
                                            offset: [5, 10],
                                          },
                                        },
                                        {
                                          name: "preventOverflow",
                                          options: {
                                            rootBoundary: "viewport",
                                            tether: false,
                                            altAxis: true,
                                          },
                                        },
                                      ]}
                                />
                            </div>
                            <label className="ml-3 mr-2 makeRoom_text">Nights: </label>
                            <input
                                value={dataRender.nights}
                                type="number"
                                disabled={!isEdit}
                                onChange={e => onChangeData(Math.abs(e.target.value), "nights", index)}
                                style={{ ...style.text, width: '30px' }} />
                        </div>

                        <div className="input-group mt-3" style={{ alignItems: 'center' }}>
                            {branchID !== 99 && <div className="input-group-prepend ">
                                <div className="input-group-text">
                                    <input
                                        type="checkbox"
                                        id="shortime"
                                        name="shortime"
                                        checked={dataRender.shortime}
                                        disabled={!isEdit}
                                        onChange={() => onChangeData(!dataRender.shortime, "shortime", index)}
                                        aria-label="Checkbox for following text input" />
                                    <label
                                        // style={style.text}
                                        className="makeRoom_text"
                                        disabled={!isEdit}
                                        onClick={() => onChangeData(!dataRender.shortime, "shortime", index)}
                                        for="shortTime">Short time</label>
                                </div>
                            </div> }                                                                         
                            <div className="input-group-prepend ">
                                <div className="input-group-text">
                                    <label className="makeRoom_text" for="`early`CheckIn">Early Check In:</label>
                                </div>
                            </div>

                            <div style={{ fontSize: '1.4rem', flex: '3' }}>
                                <DropDownAction
                                    target="timeEarly"
                                    width="100%"
                                    value={dataRender.timeEarly}
                                    dropdownMenu= {{right:0, width:'100%'}}
                                    widthInput="100%"
                                    indexData={index}
                                    onChange={onChangeData}

                                    disabled={!isEdit}
                                    dropDownItem={ {
                                        "yellow": ["07:00", "10:00","11:00", "12:00", "15:00",]}}
                                    />
                           </div>


                            <div className="input-group-prepend ">
                                <div className="input-group-text">
                                    <label className="makeRoom_text" for="lateOut">Late Out:</label>
                                </div>
                            </div>

                        <div style={{ fontSize: '1.4rem', flex: '3' }}>
                            <DropDownAction
                                //    value={value}
                                target="timeLateOut"
                                width="100%"
                                value={dataRender.timeLateOut}
                                dropdownMenu= {{right:0, width:'100%'}}
                                widthInput="100%"
                                indexData={index}
                                onChange={onChangeData}

                                disabled={!isEdit}
                                dropDownItem={{
                                     "yellow": ["12:00", "18:00", "18:30","21:00", "22:00", ]}}
                                />
                        </div>
                            </div>
                     </div>    
                </div>
                
                {/* Other Support */}
                <div style={style.children} className="d-flex">
                    <label className='makeRoom_label'>Other</label>
                    <div>
                        <input
                            type="checkbox"
                            id="spcialNonSmoking"
                            name="spcialNonSmoking"
                            checked={Number(branchID) === 99}
                            disabled={true}
                            // disabled={!isEdit}
                            // onChange={() => onChangeData(!dataRender.shortime, "shortime", index)}
                        />
                        <label className="makeRoom_text ml-1" htmlFor="spcialNonSmoking" style={{ cursor: isEdit ? 'pointer' : 'default' }} >
                            Special Non-Smoking
                        </label>

                        <input
                            type="checkbox"
                            id="shortime_99_2"
                            name="shortime_99_2"
                            className="ml-3"
                            checked={dataRender.shortime}
                            disabled={!isEdit}
                            onChange={() => onChangeData(!dataRender.shortime, "shortime", index)}
                        />
                        <label className="makeRoom_text ml-1" htmlFor="shortime_99_2" style={{ cursor: isEdit ? 'pointer' : 'default' }} onClick={() => onChangeData(!dataRender.shortime, "shortime", index)}>
                            Short time
                        </label>

                        <input
                            type="checkbox"
                            id="isNonBreakfast"
                            name="isNonBreakfast"
                            className="ml-3"
                            checked={dataRender.isNonBreakfast}
                            disabled={!isEdit}
                        />
                        <label className="makeRoom_text ml-1" htmlFor="isNonBreakfast" style={{ cursor: isEdit ? 'pointer' : 'default' }}
                                onClick={() => {
                                    if(dataRender.isNonBreakfast === false) onChangeData("NON BREAKFAST", "request1", "extend")
                                    if(dataRender.isNonBreakfast === true) onChangeData("NON BREAKFAST", "request1", "clear")
                                    
                                    onChangeData(!dataRender.isNonBreakfast, "isNonBreakfast", index);
                                }}
                        >
                            Non-Breakfast
                        </label>

                        <input
                            type="checkbox"
                            id="isOTA"
                            name="isOTA"
                            className="ml-3"
                            checked={dataRender.isOTA}
                            disabled={!isEdit}
                            onChange={() => onChangeData(!dataRender.isOTA, "isOTA", index)}
                        />
                            <label className="makeRoom_text ml-1" htmlFor="isOTA" style={{ cursor: isEdit ? 'pointer' : 'default' }}>
                                OTA {dataRender.isOTA && <span style={{ color: 'blue' }}>({dataRender.ota})</span>}
                        </label>

                        <input
                            type="checkbox"
                            id={`isTravel-${index}`}
                            name="isTravel"
                            className="ml-3"
                            checked={dataRender.isTravel === true}
                            disabled={!isEdit}
                            onChange={e => onChangeData(e.target.checked, "isTravel", index)}
                        />
                        <label className="makeRoom_text ml-1" htmlFor={`isTravel-${index}`} style={{ cursor: isEdit ? 'pointer' : 'default' }}>
                            Travel
                        </label>

                        {/* <div className='d-flex mt-2'>
                            <label className="makeRoom_text mr-2" htmlFor="promotion" style={{ cursor: isEdit ? 'pointer' : 'default' }}>
                                Promotion:
                            </label>
                            <div style={{ width: "250px" }}>
                                <DropDownAction
                                    target="promotion"
                                    width="100%"
                                    value={dataRender.promotion}
                                    dropdownMenu={{ right: 0, width: '100%' }}
                                    widthInput="145%"
                                    indexData={index}
                                    hiddenInput={true}
                                    widthItem={"340%"}
                                    onChange={onChangeData}
                                    disabled={!isEdit}
                                    dropDownItem={{ "yellow": ["LINE 30% OFF END WEEK", "LINE 40% OFF END WEEK", ""] }}
                                />
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        );
    }

    function renderButtonSchedule() {
        var result = [];

        for (let i = 0; i < dataMakeRoom.listSchedule.length; i++) {
            let index = i;

            const schedule = {
                roomSelect: dataMakeRoom.listSchedule[i]["roomSelect"],
                checkin: dataMakeRoom.listSchedule[i]["checkin"],
                checkout: dataMakeRoom.listSchedule[i]["checkout"],
            }

            result.push(
                <div className="d-flex align-items-center" style={{ position: "relative" }}>
                    <div className={"btn pt-3 pb-3 mr-1 " + (index === dataMakeRoom.scheduleSelect ? "btn-primary" : "")}
                        style={{
                            fontSize: '1.3rem',
                          //  paddingRight: '14px',
                            width: '150px',
                            border: '1px solid black'
                        }}
                        onClick={() => onChangeData(index, "scheduleSelect", "")}
                    >
                        {`R${schedule.roomSelect} (${changeDataToDDMMYYYY2(schedule.checkin).slice(0, 5)}-${schedule.checkout === "" ? "" : changeDataToDDMMYYYY2(schedule.checkout).slice(0, 5)})`}
                    </div>
                    <div style={{
                        fontSize: '1.8rem',
                        color: 'red',
                        right: 4,
                        fontWeight: 'bold',
                        position: 'absolute',
                        cursor: 'pointer',
                        display: ((index === 0 && dataMakeRoom.listSchedule.length === 1) || index === 0) ? 'none' : 'block'
                    }}
                        onClick={() => onConfigDeleteSchedule(index)}
                    >X</div>
                </div>
            )
        }
        return result;
    };

    function onConfigDeleteSchedule(index) {
        // show modal confirm delete schedule
        props.onConfirmDeleteSchedule(index)
    };

    function onClickAddMore() {
        const newData = { ...dataMakeRoom };
        newData.listSchedule.push({
            roomSelect: "",
            move: false,
            discount: dataMakeRoom.listSchedule[0].discount,
            price: "",
            checkin: "",
            checkout: "",
            nights: "",
            shortime: false,
            earlyCheckin: false,
            lateOut: false,
            timeEarly: "15:00",
            timeLateOut: "12:00",
            timeShortTime: "",
        });
        newData.scheduleSelect += 1;

        props.changeAll(newData);
    };

    function onSortListSchedule() {
        props.onSortListSchedule()
    }



    return (
        <div style={style.container} >
            <span className="d-flex mr-2"
                data-toggle="collapse"
                data-target="#collapseExample"
                role="button"
                aria-expanded="false"
                aria-controls="collapseExample">
                <h3 className="ml-2">* Room Details</h3>
                <FontAwesomeIcon
                    icon={faHandPointDown}
                    style={style.icon} />
            </span>

            <div className="collapse show" id="collapseExample">
                {/* Mail Booker: */}
                <div style={style.children}>
                    <label style={style.label}>Mail Booker:</label>
                    <input
                        type="email"
                        style={{ width: '350px', fontSize: '1.4rem' }}
                        pattern=".+@globex\.com"
                        disabled={!isEdit}
                        placeholder="Enter email"
                        value={dataMakeRoom.mail}
                        onChange={e => props.onChangeValueMakeRoom(e.target.value, "mail", "")}
                    />
                </div>
                {/* make list schedule */}

                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {renderButtonSchedule()}
                    {
                        isEdit && !props.isWaitingList && dataMakeRoomOther.area !=="waiting"&& <><div className="btn btn-warning p-3"
                                        onClick={() => onClickAddMore()}
                                        style={{ fontSize: '1.2rem', width: '80px' }}>Add More</div>
                                    {/* {(dataMakeRoom.listSchedule.length === 1 && ( Number(branchID) === 15 || Number(branchID) === 99 )) && <div className="btn btn-info p-3"
                                        onClick={() => onAddMoreSameListSchedule()}
                                        style={{ fontSize: '1.2rem', width: '100px' }}>Add Double</div>
                                        }   */}
                                    {(dataMakeRoom.listSchedule.length > 1 && ( Number(branchID) !== 11 )) && <div className="btn btn-success p-3"
                                        onClick={() => onSortListSchedule()}
                                        style={{ fontSize: '1.2rem', width: '80px' }}>Sort</div>
                                    }     
                                </>
                    }  
                </div>

                {renderSchedule()}

                {/* <br></br> */}
                {/* Payment Method */}
                <div style={style.children}>
                    <label style={style.label}>Payment Method</label>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="individual"
                            checked={dataMakeRoom.payment === "individual" || dataMakeRoom.payment === "card" || dataMakeRoom.payment === "cash"}
                            disabled={!isEdit}
                            onChange={e => props.onChangeValueMakeRoom(e.target.value, "payment", "")} />
                        <label className="form-check-label" for="inlineRadio1" style={style.text}>Individual</label>
                    </div>
                    {/* <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="cash"
                            checked={dataMakeRoom.payment === "cash"}
                            disabled={!isEdit}
                            onChange={e => props.onChangeValueMakeRoom(e.target.value, "payment", "")} />
                        <label className="form-check-label" for="inlineRadio2" style={style.text}>Cash</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio3" value="card"
                            checked={dataMakeRoom.payment === "card"}
                            disabled={!isEdit}
                            onChange={e => props.onChangeValueMakeRoom(e.target.value, "payment", "")} />
                        <label className="form-check-label" for="inlineRadio3" style={style.text}>Card</label>
                    </div> */}
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio4" value="company"
                            checked={dataMakeRoom.payment === "company"}
                            disabled={!isEdit}
                            onChange={e => props.onChangeValueMakeRoom(e.target.value, "payment", "")} />
                        <label className="form-check-label" for="inlineRadio4" style={style.text}>Company</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio5" value="pre-pay"
                            checked={dataMakeRoom.payment === "pre-pay"}
                            disabled={!isEdit}
                            onChange={e => props.onChangeValueMakeRoom(e.target.value, "payment", "")} />
                        <label className="form-check-label" for="inlineRadio5" style={style.text}>Pre-pay</label>
                    </div>
                </div>

                {/* Requirement (note booking): */}
                <div style={style.children} className="d-flex">
                    <label style={style.label}>Requirement 1:
                        <h5 style={{color:"red"}}>Use ", " to separate requests</h5>
                    </label>
                    <div>
                        <textarea
                            //   onBlur={() => props.onBlur(dataState.request2, "request2")}
                            onChange={e => props.onChangeValueMakeRoom(e.target.value, "request1", "tap")}
                            value={dataMakeRoom.request1}
                            disabled={!isEdit}
                            style={style.textarea}></textarea>
                       {
                        isEdit && <><div>
                            <button className="btn btn-primary" style={{minWidth:'60px'}} onClick={() => onChangeRequest(1, 1)}>Com 5%</button>
                            <button className="btn btn-primary ml-2" style={{minWidth:'60px'}} onClick={() => onChangeRequest(2, 1)}>laundry</button>
                            <button className="btn btn-primary ml-2" style={{minWidth:'60px'}} onClick={() => onChangeRequest(3, 1)}>5%+laundry</button>
                            <button className="btn btn-primary ml-2" style={{minWidth:'60px', background:'brown'}} onClick={() => onChangeRequest(4, 1)}>Walkin</button>
                            <button className="btn btn-success ml-2" style={{minWidth:'60px', background:'brown'}} onClick={() => onChangeRequest(5, 1)}>Shortime</button>
                            <button className="btn btn-success ml-2" style={{minWidth:'60px'}} onClick={() => onChangeRequest(6, 1)}>Line </button>
                            <button className="btn btn-danger ml-2" style={{minWidth:'60px'}} onClick={() => onChangeRequest(0, 1)}>Clear</button>
                        </div>
                        { renderRequest1Extend() }
                        </>
                       } 
                    </div>
                </div>

                <div style={style.children} className="d-flex">
                    <label style={style.label}>
                        <div>Requirement2 (note room): </div>
                        <button type="button" style={{width:"100%", fontSize:'1.1rem', color:'blue', marginTop:'4px', cursor:'pointer', background:'none', border:0, padding:0, textAlign:'left'}}
                            onClick={() => props.onOpenSettingShowRule2Water()}>(Rule 2 water)</button>
                    </label>
                    <div>      
                        <textarea
                            disabled={!isEdit}
                            onChange={e => props.onChangeValueMakeRoom(e.target.value, "request2", "")}
                            value={dataMakeRoom.request2}
                            style={{ ...style.textarea, minHeight: '100px' }}></textarea>
                      {
                        isEdit && <><div>
                            <button className="btn btn-primary" onClick={() => onChangeRequest(1, 2)}>2 water</button>
                            {branchID === 11 && <button className="btn btn-primary ml-2" onClick={() => onChangeRequest(3, 2)}>Exclude Breakfast</button>}
                            {/* <button className="btn btn-primary ml-2" onClick={() => onChangeRequest(2, 2)}>Full minibar</button>
                            <button className="btn btn-primary ml-2" onClick={() => onChangeRequest(3, 2)}>membership</button> */}
                            <button className="btn btn-danger ml-2" onClick={() => onChangeRequest(0, 2)}>Clear water</button>
                        </div>
                        {/* { branchID === 15 && renderRequest1Extend() } */}
                        </>
                        } 
                    </div>
                </div>
            </div>
        </div >
    )
};

export default MakeRoomDataRoomDetails;
